import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from '../../stores';
import * as adminStyles from '../AdminStyles.css';
import * as Constants from "../../Constants";
import { IADropDown } from '../../../dropDown/DropDown';
import { IATextField } from '../../../textField/TextField';
import { IAToggle } from '../../../toggle/Toggle';
import { IAIcon } from '../../../icon/Icon';
import { Environment } from '../../../../services/Environment';
import { Utils } from '../Utils';
import { TreeTargeting } from '../../../treeTargeting/TreeTargeting';
import TargetingUtils from '../../../treeTargeting/utils';
import { LocalizationService } from '../../../../services/LocalizationService';
import { Helper } from '../../../../Helper';
import { IAIconPicker } from '../../../iconPicker/IconPicker';
import { IAEditor } from '../../../editor/Index';
import { IAMediaSelector } from '../../../mediaSelector/MediaSelector';
import { TreeTargetingForGroups } from '../../../treeTargetingForGroups';

export interface IElementGroupSettingsPanelProps {
  navigatorStore?: NavigatorStore;
}

export interface IElementGroupSettingsPanelState {
}

@inject('navigatorStore')
@observer
export default class ElementGroupSettingsPanel extends React.Component<IElementGroupSettingsPanelProps, IElementGroupSettingsPanelState> {

  private selectedValues: any[];

  constructor(props: IElementGroupSettingsPanelProps) {
    super(props);
    this.state = {
    }
  }

  public render(): JSX.Element {
    if (this.props.navigatorStore.isShowingElementGroupSettings && this.props.navigatorStore.topItemIndexToEdit != undefined) {
      let selectedElementGroup;

      selectedElementGroup = this.props.navigatorStore.navigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit].elementGroups && this.props.navigatorStore.navigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit].elementGroups[this.props.navigatorStore.elementGroupColumnIndexToEdit] ? this.props.navigatorStore.navigator.megamenu.topItems[this.props.navigatorStore.topItemIndexToEdit].elementGroups[this.props.navigatorStore.elementGroupColumnIndexToEdit][this.props.navigatorStore.elementGroupIndexToEdit] : undefined;
      if (selectedElementGroup != undefined && selectedElementGroup.targeting != undefined && this.props.navigatorStore.applicationSettings) {
        this.selectedValues = Utils.parseSelectedTargetingValues(selectedElementGroup.targeting, this.props.navigatorStore.applicationSettings?.applicationSettings);
      }
      let showOpenInNewWindowSetting = selectedElementGroup != undefined && selectedElementGroup.type == null || selectedElementGroup != undefined && selectedElementGroup.type == "link" || selectedElementGroup != undefined && selectedElementGroup.type == "image";
      let isLink = selectedElementGroup != undefined && selectedElementGroup.type == null || selectedElementGroup != undefined && selectedElementGroup.type == "link";

      // Checking if targeting is enabled
      const showTargetOptions = TargetingUtils.checkIfUsesTargeting(this.props.navigatorStore.applicationSettings, this.props.navigatorStore.instance);
      let top = 51;
      switch (Helper.getDisplayEnvironment()) {
        case "ExternalEnvironment":
          top = 51;
          break;
        case "Sharepoint":
          top = 161;
          break;
      }
      return (
        <div
          className={adminStyles.panel}
          style={{
            right: this.props.navigatorStore.isShowingElementGroupSettings ? "0px" : "-400px",
            top: top,
            height: `calc(100% - ${top}px)`,
            overflowY: "auto"
          }}
        >
          <div className={adminStyles.panelHeader}>
            {new LocalizationService().strings.Navigator_Settings_ElementGroup}
            <IAIcon
              title={"Close"}
              size={20}
              color="#ffffff"
              onClick={() => {
                this.props.navigatorStore.toggleElementGroupSettings();
              }}
              style={{
                float: "right",
                padding: "5px 10px",
                cursor: "pointer"
              }}
            />
          </div>
          <div className={adminStyles.content}>
            <div>
              <IADropDown
                label={new LocalizationService().strings.Navigator_Content_ElementType}
                selectedOption={this.props.navigatorStore.elementGroupIndexToEdit != undefined ? selectedElementGroup.type : undefined}
                options={Constants.ELEMENT_TYPES}
                borderRadius={5}
                onChange={(type: string) => {
                  if (type) {
                    this.props.navigatorStore.setElementGroupType(type.toLowerCase());
                    this.forceUpdate();
                  } else {
                    this.props.navigatorStore.setElementGroupType("link");
                  }
                }}
              />
              <div className={adminStyles.panelDivider} />
              {isLink &&
                <IATextField
                  label={new LocalizationService().strings.Navigator_Content_Titel}
                  text={selectedElementGroup.config.headline}
                  onChange={(text: string) => this.props.navigatorStore.setElementGroupHeadline(text)}
                  borderRadius={5}
                />
              }
              {selectedElementGroup.type === "image" &&
                <>
                  <IAMediaSelector
                    label={new LocalizationService().strings.Navigator_Content_ElementImage}
                    showPreview={false}
                    fileType="image"
                    highlightColor={this.props.navigatorStore.navigator.design.menuBar.highlightColor}
                    token={this.props.navigatorStore.token}
                    tenant={this.props.navigatorStore.tenant.substring(0, this.props.navigatorStore.tenant.indexOf('.'))}
                    selectedImage={selectedElementGroup.config.imageUrl}
                    environment={this.props.navigatorStore.environment}
                    uploadUrl={`${Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}/api/${this.props.navigatorStore.tenant}/image?site=IntraActive-NavigatorAdmin&relativeUrl=${encodeURIComponent("lists/IANavigatorImages")}`}
                    onChange={(imageUrl: string) => {
                      this.props.navigatorStore.setElementGroupImageUrl(imageUrl);
                      this.forceUpdate();
                    }}
                    style={{
                      clear: "both",
                      marginTop: 20,
                      float: "left"
                    }}
                  />
                  <div className={adminStyles.panelDivider} />
                </>
              }
              {selectedElementGroup.type !== "text" &&
                <IATextField
                  label={new LocalizationService().strings.Navigator_Content_Url}
                  text={selectedElementGroup.config.url}
                  borderRadius={5}
                  onChange={(url: string) => {
                    this.props.navigatorStore.setElementGroupUrl(selectedElementGroup.type === "video" ? Helper.convertUrlToEmbedUrl(url) : url);
                  }}
                />
              }
              {selectedElementGroup.type === "text" &&
                <IAEditor
                  simple={false}
                  useImageAPI
                  uploadImagesToSharepoint
                  token={this.props.navigatorStore.token}
                  tenant={this.props.navigatorStore.tenant}
                  environment={this.props.navigatorStore.environment}
                  isMobile={this.props.navigatorStore.isMobile}
                  highlightColor={"#333333"}
                  content={selectedElementGroup.config.content}
                  onChange={(content) => {
                    selectedElementGroup.config.content = content;
                    this.props.navigatorStore.checkForChanges();
                  }}
                  onStyleChange={(style) => {
                    console.log(style)
                  }}
                  placeholder={"Type here"}
                  style={{
                    border: "1px solid #eeeeee",
                    padding: 5,
                    boxSizing: "border-box",
                    marginTop: 20,
                    width: "calc(100% - 10px)"
                  }}
                  fontSizeSupport
                  fontStyleSupport
                  textAlignmentSupport
                  textColorSupport
                  clearStylingSupport
                  emojiSupport
                  fontFamilySupport
                />
              }
              {showOpenInNewWindowSetting &&
                <IAToggle
                  label={new LocalizationService().strings.Navigator_Content_LinkOpen}
                  checked={selectedElementGroup.config.openInNewWindow}
                  color={"#333333"}
                  onChange={() => {
                    this.props.navigatorStore.setElementGroupOpenInNewWindow();
                    this.forceUpdate();
                  }}
                  style={{
                    marginTop: 20
                  }}
                />
              }
              {isLink &&
                <IAIconPicker
                  label={new LocalizationService().strings.Navigator_Content_Icon}
                  selectedIcon={selectedElementGroup.config.icon}
                  color={"#333333"}
                  select={(icon: string) => {
                    this.props.navigatorStore.setElementGroupIcon(icon);
                    this.forceUpdate();
                  }}
                  shouldBeAbleToClear={true}
                  clear={() => {
                    this.props.navigatorStore.setElementGroupIcon(undefined);
                    this.forceUpdate();
                  }}
                />
              }
              <div className={adminStyles.panelDivider} />
              {showTargetOptions &&
                <div style={{
                  marginTop: "20px", clear: "both", float: "left", width: "100%"
                }}>
                  {this.props.navigatorStore.applicationSettings?.applicationSettings?.toLowerCase() === "profile data" ?
                    <TreeTargeting
                      application={"navigator"}
                      environment={this.props.navigatorStore.environment}
                      applicationData={this.props.navigatorStore.applicationSettings}
                      instance={this.props.navigatorStore.instance}
                      tenant={this.props.navigatorStore.tenant}
                      authToken={this.props.navigatorStore.token}
                      apiUrl={Environment.getEnvironmentForMainAPI(this.props.navigatorStore.environment)}
                      selectedValues={this.selectedValues}
                      currenNodeStructure={selectedElementGroup.targetingExistingStructure}
                      operator={selectedElementGroup.targeting != null ? selectedElementGroup.targeting.operator : "AND"}
                      showTarget={selectedElementGroup.targeting != null ? selectedElementGroup.targeting.enabled : false}
                      onShowTargetChanged={(showTarget: boolean) => {
                        if (!selectedElementGroup.targeting) {
                          selectedElementGroup.targeting = {
                            enabled: showTarget,
                            operator: "AND"
                          };
                        } else {
                          selectedElementGroup.targeting.enabled = showTarget;
                        }
                        this.props.navigatorStore.checkForChanges();
                      }}
                      onChange={(targeting, applicationSettings, groups, _selecteAll, targetingExistingStructure) => {

                        if (targeting) {
                          selectedElementGroup.targeting.targetingFields = Utils.processReturnTreeTargeting(targeting);
                        }

                        // Processing targeting group data
                        if (groups) {
                          selectedElementGroup.targeting.groupData = JSON.stringify(groups);
                          selectedElementGroup.targeting.targetingGroups = [];

                          if (groups.length > 0) {
                            groups.forEach((x) => {
                              selectedElementGroup.targeting.targetingGroups.push(x.id.toString());
                            });
                          }
                        }

                        this.props.navigatorStore.applicationSettings = applicationSettings;
                        selectedElementGroup.targetingExistingStructure = targetingExistingStructure;
                        this.props.navigatorStore.checkForChanges();
                      }}
                      onLogicalOperatorChanged={(operator: string) => {
                        selectedElementGroup.targeting.operator = operator;
                      }}
                      highlightColor={this.props.navigatorStore.adminColor}
                      nodeComparison={"label"}
                    />
                    :
                    <TreeTargetingForGroups
                      environment={this.props.navigatorStore.environment}
                      tenant={this.props.navigatorStore.tenant.replace(".sharepoint.com", "")}
                      application={"navigator"}
                      applicationData={this.props.navigatorStore.applicationSettings}
                      selectedGroupIds={this.selectedValues?.map((itemData) => itemData.id)}
                      highlightColor={this.props.navigatorStore.adminColor}
                      showTarget={selectedElementGroup.targeting != null ? selectedElementGroup.targeting.enabled : false}
                      onShowTargetChanged={(showTarget: boolean) => {
                        if (!selectedElementGroup.targeting) {
                          selectedElementGroup.targeting = {
                            enabled: showTarget,
                            operator: "AND"
                          };
                        } else {
                          selectedElementGroup.targeting.enabled = showTarget;
                        }
                        this.props.navigatorStore.checkForChanges();
                      }}
                      onGroupIdsUpdated={(ids: number[]) => {
                        selectedElementGroup.targeting.targetingGroups = ids;
                        this.forceUpdate();
                        this.props.navigatorStore.checkForChanges();
                      }}
                    />
                  }
                </div>
              }
              <div className={adminStyles.panelDivider} />
              {!this.props.navigatorStore.isCreatingContent &&
                <div
                  className={adminStyles.settingsPanelDeleteButton}
                  onClick={() => {
                    this.props.navigatorStore.deleteSelectedElementGroup();
                  }}
                  style={{
                    backgroundColor: "#eeeeee"
                  }}
                >
                  <div
                    className={adminStyles.settingsPanelDeleteButtonIcon}
                  >
                    <IAIcon
                      title="Trash"
                      size={20}
                      color="#333333"
                    />
                  </div>
                  <div
                    className={adminStyles.settingsPanelDeleteButtonText}
                  >
                    {new LocalizationService().strings.Navigator_ElementGroupPanel_Delete}
                  </div>
                </div>
              }
              <div
                className={adminStyles.settingsPanelDeleteButton}
                onClick={() => {
                  if (!this.props.navigatorStore.isCreatingContent) {
                    this.props.navigatorStore.toggleElementGroupSettings();
                  } else {
                    this.props.navigatorStore.deleteSelectedElementGroup();
                  }
                }}
                style={{
                  backgroundColor: "#eeeeee"
                }}
              >
                <div className={adminStyles.settingsPanelDeleteButtonText}>
                  {new LocalizationService().strings.Navigator_ElementGroupPanel_Cancel}
                </div>
              </div>
            </div>
          </div>
        </div >
      );
    } else {
      return (<div></div>);
    }
  }
}